// shared/components/UIElements/TutorialModal.jsx
import React from "react";
import "./TutorialModal.scss";

const TutorialModal = ({ isOpen, onClose, type, content, title }) => {
  if (!isOpen) return null;

  // Extrair ID do vídeo do Vimeo da URL
  const getVimeoId = (url) => {
    const match = url.match(/vimeo\.com\/(\d+)/);
    return match ? match[1] : null;
  };

  const renderContent = () => {
    if (type === "video") {
      const vimeoId = getVimeoId(content);
      if (!vimeoId) {
        return <p className="error">URL de vídeo inválida</p>;
      }

      return (
        <div className="tutorial-modal__video-container">
          <iframe
            src={`https://player.vimeo.com/video/${vimeoId}?title=0&byline=0&portrait=0`}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title={title}
          ></iframe>
        </div>
      );
    }

    if (type === "text") {
      return (
        <div className="tutorial-modal__text-container">
          <div
            className="tutorial-modal__text-content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      );
    }

    return null;
  };

  return (
    <div className="tutorial-modal-overlay" onClick={onClose}>
      <div className="tutorial-modal" onClick={(e) => e.stopPropagation()}>
        <div className="tutorial-modal__header">
          <h2>{title}</h2>
          <button
            className="tutorial-modal__close-btn"
            onClick={onClose}
            aria-label="Fechar"
          >
            ×
          </button>
        </div>
        <div className="tutorial-modal__content">{renderContent()}</div>
      </div>
    </div>
  );
};

export default TutorialModal;
